import { radians, rotate } from '../../../../Math.js';
import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { IVector3 } from '../../../../api.js';
import { vector_3 } from '../../../utility/Conversion.js';
import { LightVisualizer } from './LightVisualizer.js';
export class LineLightVisualizer extends LightVisualizer {
    constructor(light, line_mananger, color_mode, scene) {
        super(light, line_mananger, color_mode, scene);
        this._minimum_line_length = 0;
        this.update();
    }
    update() {
        super.update_visualizer();
        const { line_a, line_b } = this._light.get_world_endpoints();
        const main_axis_p1 = vector_3(line_a);
        const main_axis_p2 = vector_3(line_b);
        const main_axis = main_axis_p2.subtract(main_axis_p1);
        const far_endpoints = this.get_far_endpoints(main_axis, main_axis_p1, main_axis_p2);
        this.draw_main_lines(vector_3(main_axis_p1), vector_3(main_axis_p2), far_endpoints, this._line_color, this._line_thickness);
        this.draw_far_lines([main_axis_p1, main_axis_p2], far_endpoints, this._line_color, this._line_thickness, main_axis);
    }
    get_far_endpoints(main_axis, main_axis_p1, main_axis_p2) {
        const line_normal = this._light.get_world_line_normal();
        const beam_leg_angle = (this._light.angle_direction_radians + this._light.angle_range_degrees / 2) * Math.PI / 180;
        const rotated_1 = rotate(new IVector3(line_normal.x, line_normal.y, line_normal.z), beam_leg_angle, main_axis);
        const line_normal_rotated_1 = new BABYLON_Vector3(rotated_1.x, rotated_1.y, rotated_1.z);
        const rotated_2 = rotate(new IVector3(line_normal.x, line_normal.y, line_normal.z), -beam_leg_angle, main_axis);
        const line_normal_rotated_2 = new BABYLON_Vector3(rotated_2.x, rotated_2.y, rotated_2.z);
        const beam_vector_1 = line_normal_rotated_1.scale(this._light_range);
        const beam_vector_2 = line_normal_rotated_2.scale(this._light_range);
        return [beam_vector_1.add(main_axis_p1), beam_vector_2.add(main_axis_p1), beam_vector_1.add(main_axis_p2),
            beam_vector_2.add(main_axis_p2)];
    }
    draw_main_lines(main_axis_p1, main_axis_p2, far_endpoints, color, line_thickness) {
        this.draw_line(0, main_axis_p1, main_axis_p2, color, line_thickness);
        for (let i = 1; i < 5; i++) {
            this.draw_line(i, i < 3 ? main_axis_p1 : main_axis_p2, vector_3(far_endpoints[i - 1]), color, line_thickness);
        }
    }
    draw_far_lines(main_axis_points, far_endpoints, color, line_thickness, main_axis) {
        const vec_3_endpoints = far_endpoints.map(vec => vector_3(vec));
        this.draw_line(5, vec_3_endpoints[0], vec_3_endpoints[2], color, line_thickness);
        this.draw_line(6, vec_3_endpoints[1], vec_3_endpoints[3], color, line_thickness);
        // Draw curves
        this.dispose(7);
        const delta_angle = radians(this._light.angle_range_degrees);
        const line_index = this.draw_curve(7, vec_3_endpoints[0], vec_3_endpoints[1], main_axis, main_axis_points[0], delta_angle);
        this.draw_curve(line_index + 1, vec_3_endpoints[2], vec_3_endpoints[3], main_axis, main_axis_points[1], delta_angle);
    }
}
//# sourceMappingURL=LineLightVisualizer.js.map